// Libs
import React from 'react';
import { Router, Route, browserHistory } from 'react-router';
import Library from './components/Library';
import Watch from './components/Watch';
import NotFound from './components/NotFound';

// Components
import App from './App';


// Routes
const routes = (
    <Router history={browserHistory}>
        <Route component={App}>
            <Route path="/" component={Library} />
            <Route path="/watch/:id" component={Watch} title="Watch" />
            <Route path="*" component={NotFound} />
        </Route>
    </Router>
);

export default routes;


// WEBPACK FOOTER //
// ./src/router.js